export default {
	ido_contact_person_actions: 'Aktionen',
	ido_contact_person_cancel: 'Abbrechen',
	ido_contact_person_close_edit_dialog: 'Schließen',
	ido_contact_person_confirm_delete_message: 'Möchten Sie den Eintrag wirklich löschen?',
	ido_contact_person_confirm_delete_title: 'Löschen bestätigen',
	ido_contact_person_create: 'Erstellen',
	ido_contact_person_delete: 'Löschen',
	ido_contact_person_edit: 'Bearbeiten',
	ido_contact_person_save: 'Speichern',
};
